import { Permission } from '@/lib/permissions/v1'

export enum OprhanedInvoiceItemsRouteName {
    Index = 'finance.orphaned-invoice-items.index',
}

export default {
    path: 'orphaned-invoice-items',
    name: OprhanedInvoiceItemsRouteName.Index,
    component: () => import('@/views/finance/orphaned-invoice-items/Index.vue'),
    meta: {
        label: 'Orphaned Invoice Items',
        auth: true,
        permission: Permission.InvoiceView,
        icon: 'fal fa-file-invoice-dollar fa-fw',
        location: 'sidebar',
        parent: 'finance',
    },
}
